
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'MAGIC',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/MAGIC.vue